import { Pencil, Trash2 } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { RowAction } from '@nucleus-commerce/admin-kit/index-table';
import type { HelpCategory } from '@nucleus-commerce/api-client/admin';

/** Edit and delete; the page offers them only with `help.write`. */
export function useHelpCategoryRowActions({
  onEdit,
  onDelete,
}: {
  onEdit: (row: HelpCategory) => void;
  onDelete: (row: HelpCategory) => void;
}) {
  const { t } = useTranslation('helpCenter');
  return useMemo<Array<RowAction<HelpCategory>>>(
    () => [
      { id: 'edit', label: t('actions.edit'), icon: <Pencil aria-hidden />, onAction: onEdit },
      {
        id: 'delete',
        label: t('actions.delete'),
        icon: <Trash2 aria-hidden />,
        variant: 'destructive',
        onAction: onDelete,
      },
    ],
    [onDelete, onEdit, t],
  );
}
